export default __webpack_public_path__ + "static/media/dashboard_avatar.71a8ca63.png";